// extracted by mini-css-extract-plugin
export default {"root":"Nav_root__CG6AX","mobileMenuActive":"Nav_mobileMenuActive__szjPP","rotate":"Nav_rotate__V1yuG","expanded":"Nav_expanded__JbJoZ","collapsed":"Nav_collapsed__4H9rQ"};